<template>
  <div>
    <navigationFab />

    <v-img
      src="https://images.unsplash.com/photo-1528302137539-73565e0ab964?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=1351&q=80"
      gradient="#FFFFFF00, #000000"
      max-height="25vh"
    >
      <v-row>
        <v-col class="mt-16" align="center">
          <span class="primary--text text-md-h2 text-h3 font-weight-bold"
            >Playlist Selection</span
          >
        </v-col>
      </v-row>
    </v-img>
    <div v-if="!loading" class="px-8 centered">
      <v-row>
        <v-col cols="3"></v-col>
        <v-col cols="12" md="6" align="center">
          <v-form v-model="validPlaylists" v-on:submit.prevent>
            <v-row class="py-0">
              <v-col class="py-0 v-centered" align="end">
                <v-tooltip top color="primary">
                  <template v-slot:activator="{ on, attrs }">
                    <span
                      class="text-md-h6 text-subtitle-1"
                      v-bind="attrs"
                      v-on="on"
                      >Current Favourites Playlist</span
                    >
                  </template>
                  <span>Playlist with your current favourtie songs</span>
                </v-tooltip>
              </v-col>
              <v-col class="py-0" align="start">
                <v-autocomplete
                  v-model="curPlaylist"
                  label="Current Favourites"
                  color="primary"
                  :items="playlists"
                  @change="setValueCurPlaylist"
                  placeholder="My Fav Songs <3"
                  :rules="[curDifferAll, notEmpty]"
                >
                  <template v-slot:item="{ item }">
                    <v-img
                      :src="item.cover"
                      max-width="50"
                      aspect-ratio="1"
                    ></v-img>
                    <span
                      class="ml-4"
                      style="max-width: 290px; max-height: 50px"
                      >{{ item.text }}</span
                    >
                  </template>
                </v-autocomplete>
              </v-col>
            </v-row>
            <v-row class="py-0">
              <v-col class="py-0 v-centered" align="end">
                <v-tooltip top color="primary">
                  <template v-slot:activator="{ on, attrs }">
                    <div class="d-flex">
                      <span
                        class="text-md-h6 text-subtitle-1"
                        v-bind="attrs"
                        v-on="on"
                        >Alltime Favourites Playlist</span
                      >
                    </div>
                  </template>
                  <span>Playlist with all your favourtie songs ever</span>
                </v-tooltip>
              </v-col>
              <v-col class="py-0" align="start">
                <v-autocomplete
                  v-model="allPlaylist"
                  label="Alltime Favourites"
                  color="primary"
                  :items="playlists"
                  @change="setValueAllPlaylist"
                  placeholder="All my favourtie songs :)"
                  :rules="[allDifferCur, notEmpty]"
                >
                  <template v-slot:item="{ item }">
                    <v-img
                      :src="item.cover"
                      max-width="50"
                      aspect-ratio="1"
                    ></v-img>
                    <span
                      class="ml-4"
                      style="max-width: 290px; max-height: 50px"
                      >{{ item.text }}</span
                    >
                  </template>
                </v-autocomplete>
              </v-col>
            </v-row>
            <v-row>
              <v-col class="py-0 v-centered" align="end">
                <v-tooltip top color="primary">
                  <template v-slot:activator="{ on, attrs }">
                    <span v-bind="attrs" v-on="on"
                      >Create Favourites History Playlist?</span
                    >
                  </template>
                  <span>Name for the History-Playlists</span>
                </v-tooltip>
              </v-col>
              <v-col class="py-0" align="start">
                <v-checkbox v-model="createHistory"></v-checkbox>
              </v-col>
            </v-row>
            <v-row v-if="createHistory" class="py-0">
              <v-col class="py-0 v-centered" align="end">
                <v-tooltip top color="primary">
                  <template v-slot:activator="{ on, attrs }">
                    <span
                      class="text-md-h6 text-subtitle-1"
                      v-bind="attrs"
                      v-on="on"
                      >Favourites History Playlist Name</span
                    >
                  </template>
                  <span>Name for the History-Playlists</span>
                </v-tooltip>
              </v-col>
              <v-col class="py-0" align="start">
                <v-text-field
                  label="Favourites History"
                  color="primary"
                  placeholder="Throwback Time"
                  :rules="[notEmpty]"
                  v-model="hisPlaylist"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row class="py-0">
              <v-col class="py-0 v-centered" align="end">
                <v-tooltip top color="primary">
                  <template v-slot:activator="{ on, attrs }">
                    <span
                      class="text-md-h6 text-subtitle-1"
                      v-bind="attrs"
                      v-on="on"
                      >Current Favourites Playlist Behavior</span
                    >
                  </template>
                  <span>How to behave after Listifying</span>
                </v-tooltip>
              </v-col>
              <v-col class="py-0" align="start">
                <v-radio-group mandatory v-model="curPlaylistRadio">
                  <v-radio
                    label="Clear Current Favourites Playlist after Listifying"
                    value="clear"
                  ></v-radio>
                  <v-radio
                    label="Edit Current Favourites Playlist after Listifying"
                    value="edit"
                  ></v-radio>
                  <v-radio
                    label="Don't touch Current Favourites Playlist"
                    value="none"
                  ></v-radio>
                </v-radio-group>
              </v-col>
            </v-row>
            <v-row class="py-0">
              <v-col class="py-0 v-centered" align="end">Remember me?</v-col>
              <v-col class="py-0" align="start">
                <v-checkbox v-model="remember"></v-checkbox>
              </v-col>
            </v-row>
          </v-form>
          <v-row>
            <v-col cols="3"></v-col>
            <v-col class="mt-12" cols="12" md="6" align="center">
              <v-btn
                color="primary"
                @click="startListify"
                :loading="btnLoading"
                :disabled="!validPlaylists"
                >Go!</v-btn
              >
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </div>
    <div v-else class="px-8 centered">
      <v-row>
        <v-col cols="3"></v-col>
        <v-col cols="12" md="6" align="center">
          <v-progress-circular
            indeterminate
            color="primary"
          ></v-progress-circular>
        </v-col>
      </v-row>
    </div>
  </div>
</template>

<script>
import navigationFab from "../components/general/navigationFab";
export default {
  name: "PlaylistSelection",
  title: "Playlist-Selection",
  components: {
    navigationFab,
  },
  data() {
    return {
      profile: {},
      playlists: [],
      curPlaylist: "",
      allPlaylist: "",
      hisPlaylist: "",
      btnLoading: false,
      validPlaylists: false,
      curPlaylistRadio: "none",
      remember: true,
      loading: true,
      createHistory: true,
    };
  },
  methods: {
    //rules
    allDifferCur: function() {
      if (this.curPlaylist === this.allPlaylist) {
        return "Alltime and Current mustn't be the same";
      }
      return true;
    },
    curDifferAll: function() {
      if (this.curPlaylist === this.allPlaylist) {
        return "Current and Alltime mustn't be the same";
      }
      return true;
    },
    notEmpty: function(input) {
      if (input) {
        return true;
      }
      return "Field must be filled";
    },

    //methods
    fillPlaylists: function() {
      for (let i = 0; i < this.$globalState.userPlaylists.length; i++) {
        let element = {
          text: this.$globalState.userPlaylists[i].name,
          value: this.$globalState.userPlaylists[i].id,
          cover: "https://i.imgur.com/5bZoMgN.jpg",
        };
        if (this.$globalState.userPlaylists[i].images[0]) {
          element.cover = this.$globalState.userPlaylists[i].images[0].url;
        }
        this.playlists.push(element);
      }
    },
    setValueCurPlaylist: function(id) {
      this.curPlaylist = id;
    },
    setValueAllPlaylist: function(id) {
      this.allPlaylist = id;
    },
    startListify: async function() {
      this.btnLoading = true;
      //starting listify
      let payload = {
        authToken: this.$cookies.get("authToken"),
        listify: {
          curPlaylist: this.curPlaylist,
          allPlaylist: this.allPlaylist,
          hisPlaylist: this.hisPlaylist,
          curPlaylistBehavior: this.curPlaylistRadio,
          createHistory: this.createHistory,
        },
        storeUser: this.remember,
      };

      let response = await fetch(this.$apiUrl + "/task/listify", {
        method: "POST",
        body: JSON.stringify(payload),
      });

      let responseData = await response.json();

      if (responseData.state) {
        this.$globalState.listifyInfo = responseData.listifyInfo;
        this.$globalState.listify = responseData.listify;
        this.$globalState.userRef = responseData.userRef;
        if (responseData.listify.curPlaylistBehavior === "edit") {
          this.$router.push("/editCurrentFavs");
        } else if (
          responseData.listify.curPlaylistBehavior === "clear" ||
          responseData.listify.curPlaylistBehavior === "none"
        ) {
          this.$router.push("/listified");
        }
      } else if (responseData.notifyError) {
        let Notify = {
          duration: 4000,
          type: "error",
          headline: "Can't Listify!",
          message: responseData.msg,
        };
        this.$globalState.addNotification(Notify);
        this.btnLoading = false;
      }
    },
    setStartValues: function() {
      if (this.$globalState.listify) {
        if (this.$globalState.listify.curPlaylist) {
          this.curPlaylist = this.$globalState.listify.curPlaylist;
        }
        if (this.$globalState.listify.allPlaylist) {
          this.allPlaylist = this.$globalState.listify.allPlaylist;
        }
        if (this.$globalState.listify.hisPlaylist) {
          this.hisPlaylist = this.$globalState.listify.hisPlaylist;
        }
        if (this.$globalState.listify.curPlaylistBehavior) {
          this.curPlaylistRadio = this.$globalState.listify.curPlaylistBehavior;
        }
        if (this.$globalState.listify.createHistory != null) {
          this.createHistory = this.$globalState.listify.createHistory;
        }
      }
    },
  },
  async mounted() {
    this.profile = this.$globalState.userProfile;
    this.fillPlaylists();
    this.setStartValues();
    this.loading = false;
  },
};
</script>

<style scoped>
.v-centered {
  display: grid;
  place-items: center end;
}

.remaining-height {
  height: 70vh;
}
.centered {
  display: grid;
  place-items: center stretch;
  height: 70vh;
}
.ac-list-item {
  max-width: 400px;
}
</style>
